module.exports = __webpack_public_path__ + "static/TangleTower0-57e0007c813824813ffbcbd571126306.webp";